<script setup lang="ts">
import { api } from '@/api'
import { ref, watch } from 'vue'
import type Prompt from '@/api/resources/prompts/model'
import { ElMessage } from 'element-plus'
import { useRoute } from 'vue-router'

const route = useRoute()

const prompts = ref<Prompt[]>()
const currentPrompt = ref<string>()
const init = async () => {
  prompts.value = await api.prompts.get(route.params.status as string)
  currentPrompt.value = prompts.value.find((prompt) => !prompt.deleted_at)?.prompt
}

init()

const save = async () => {
  await api.prompts.create({
    prompt: currentPrompt.value!,
    status: route.params.status as string,
  })
  ElMessage.success('Prompt saved')
  init()
}

watch(
  () => route.params.status,
  () => {
    init()
  },
)
</script>

<template>
  <main>
    <h3>{{ route.params.status }}</h3>
    <el-form>
      <el-form-item>
        <el-input type="textarea" v-model="currentPrompt" autosize />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save" :disabled="!currentPrompt">Save</el-button>
      </el-form-item>
    </el-form>
    <el-divider />
    <h2>History</h2>
    <template v-for="prompt in prompts" :key="prompt.id">
      <el-card v-if="prompt.deleted_at">
        <el-container direction="vertical">
          <el-header>
            <el-space>
              <el-tag type="success">Created: {{ prompt.created_at }}</el-tag>
              <el-tag type="danger">Deleted: {{ prompt.deleted_at }}</el-tag>
            </el-space>
          </el-header>
          <el-main>
            <el-input type="textarea" v-model="prompt.prompt" autosize disabled />
          </el-main>
        </el-container>
      </el-card>
    </template>
  </main>
</template>
